import {CONSTANTS} from '@/config/constants';

export default {
  name: 'Footer',
  //---components
  components: {
  },
  //--data
  data () {
    return {
      footerData: {
        siteUrl: process.env.VUE_APP_PTF_SITE_URL,
        logoSrc: require('@/assets/img/src/logo_fox--footer@3x.png'),
        youtubeProfileUri: CONSTANTS.APP_YOUTUBE_PROFILE_URI,
        facebookProfileUri: CONSTANTS.APP_FACEBOOK_PROFILE_URI,
        twitterProfileUri: CONSTANTS.APP_TWITTER_PROFILE_URI,
        links: [
          {
            title: 'About Us',
            url: process.env.VUE_APP_PTF_SITE_URL + '/about-us'
          },
          {
            title: 'Contact Us',
            url: process.env.VUE_APP_PTF_SITE_URL + '/contact-us'
          },
          {
            title: 'Terms of Use',
            url: process.env.VUE_APP_PTF_SITE_URL + '/terms-of-use'
          },
          {
            title: 'Privacy',
            url: process.env.VUE_APP_PTF_SITE_URL + '/privacy-policy'
          },
          {
            title: 'FAQ',
            url: process.env.VUE_APP_PTF_SITE_URL + '/faq'
          },
        ],
      }
    }
  },
  //---hooks
  computed: {
    currentYear: function () {
      return new Date().getFullYear();
    }
  }
  //---methods
}